<template>
  <div class="page">
    <div class="page__header" style="margin-bottom: 25px">
      <h1 style="margin-top: 10px">Collection</h1>
      <div class="page__header-search">
        <BaseSelect
          class="form-control--grey form-control--xs"
          placeholder="Search by"
          :selected="searchType"
          :items="searchTypes"
          @input="serachingType"
        ></BaseSelect>
        <BaseInput
          class="form-control--grey form-control--xs"
          style="max-width: 65rem"
          placeholder="Search"
          :icon="true"
          :timeout="true"
          :element="tableData.search"
          @input="searchItems"
        >
          <template #icon>
            <IconSearch color="#000" height="16" width="16"></IconSearch>
          </template>
        </BaseInput>
      </div>
    </div>
    <div class="page__header">
      <HorisontalTabsList :tabs="tabs"></HorisontalTabsList>
      <IconButton
        class="button--admin button--auto button--outline-grey button--ml-15"
        text="add publication"
        @click="modal = true"
      >
        <IconPlusBold></IconPlusBold>
      </IconButton>
    </div>
    <Table
      :loading="loading"
      :items="items"
      :headerItems="headerItems"
      :tableData="tableData"
      :hasMorePages="hasMorePages"
      @sortTable="sortTable"
      @clickAction="clickAction"
      @loadMore="loadMore"
    ></Table>
    <Publication
      v-if="modal"
      :modal="modal"
      :item="item"
      @hideModal="modal = false"
      @createItem="createPublication"
      @updateItem="updatePublication"
      @removePublication="confirmRemovePublication"
    ></Publication>
  </div>
</template>
<script>
import BaseInput from "@/components/inputs/BaseInput.vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import HorisontalTabsList from "@/components/HorisontalTabsList.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import IconPlusBold from "@/components/icons/IconPlusBold.vue";
import Table from "@/components/Table.vue";
import Publication from "./Publication.vue";
import BaseSelect from "@/components/inputs/BaseSelect.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    BaseInput,
    IconSearch,
    HorisontalTabsList,
    IconButton,
    IconPlusBold,
    Table,
    Publication,
    BaseSelect,
  },
  data() {
    return {
      tabs: [
        {
          title: "Artworks",
          path: "/admin/collection/artworks",
          key: "artwork",
        },
        {
          title: "Artists",
          path: "/admin/collection/artists",
          key: "artists",
        },
        {
          title: "Publications",
          path: "/admin/collection/publications",
          key: "publications",
        },
      ],
      modal: false,
      tableData: {
        page: 1,
        sort: "title",
        order: "asc",
        status: "",
        search: "",
        search_type: "",
      },
      searchTypes: [
        {
          id: "title",
          title: "Title",
        },
        {
          id: "type",
          title: "Type",
        },
        {
          id: "author",
          title: "Author",
        },
      ],
      searchType: "title",
    };
  },
  async created() {
    await this.apiGetPublications(this.tableData);
    this.initialItem();
  },
  computed: {
    ...mapGetters("publications", {
      items: "getItems",
      headerItems: "getItemsHeaders",
      loading: "getLoading",
      hasMorePages: "getHasMorePages",
      item: "getItem",
    }),
  },
  watch: {
    modal(val) {
      if (!val) {
        this.initialItem();
        this.setError(null);
      }
    },
  },
  methods: {
    ...mapActions("publications", [
      "apiGetPublications",
      "apiGetPublication",
      "apiPostPublication",
      "apiPutPublication",
      "apiDeletePublication",
    ]),
    ...mapMutations("publications", ["initialItem", "setError"]),
    async sortTable({ sort, order }) {
      let data = { ...this.tableData, page: 1, sort, order };
      let success = await this.apiGetPublications(data);
      if (success) {
        this.tableData = data;
      }
    },
    async loadMore() {
      if (this.hasMorePages) {
        let data = { ...this.tableData, page: this.tableData.page + 1 };
        let success = await this.apiGetPublications(data);
        if (success) {
          this.tableData = data;
        }
      }
    },
    serachingType(value) {
      this.searchType = value.id;
      this.searchItems(this.tableData.search);
    },
    async searchItems(val) {
      if (this.tableData.search != val || this.tableData.search_type != this.searchType) {
        let data = { ...this.tableData, page: 1, search: val, search_type: this.searchType };
        let success = await this.apiGetPublications(data);
        if (success) {
          this.tableData = data;
        }
      }
    },
    async clickAction({ key, id, item }) {
      switch (key) {
        case "edit": {
          let result = await this.apiGetPublication(id);
          if (result) {
            this.modal = true;
          }
          break;
        }
        case "delete": {
          let result = await this.confirmRemovePublication(item);
          if (result) {
            this.modal = true;
          }
          break;
        }
      }
    },
    async createPublication({ data }) {
      let result = await this.apiPostPublication(data);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPublications(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
      }
    },
    async updatePublication({ data }) {
      let result = await this.apiPutPublication(data);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPublications(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
      }
    },
    confirmRemovePublication(item) {
      this.$swal({
        title: `Delete ${item.title}`,
        html: "<h5>Are you sure? <br/> This cannot be undone.",
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        denyButtonText: "Delete",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.value === false) {
          this.removePublication(item.id);
        }
      });
    },
    async removePublication(id) {
      let result = await this.apiDeletePublication(id);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPublications(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
      }
    },
  },
};
</script>
